var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_365_7707",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_365_7707",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL3SURBVHgB7VjdcdswDIZzfS83qDaIuwG7gUdwN8gGUidwOoHdCewNpE7gdAKpEziZACGPgI0wFH8kJ5eHfHc8SiT4EQBBEhLAJ+ZhAROBiMpUK1NuTalMWYruRyoPpvy19WKxGOA9YBTTprRYjr0dC4XI9iCR16Zor8t6agDnLYaiogNUnSk/r+pRo1zteeNkyn2OR8jjOxojUcNc2DgLLGdD8VfKVdFYf9mLuaRyR0HW20lgJkjRXvAeJylJ1s23NMytPP62lKCWymXIr2nCnjxin9cZ4/bFMUlLIJdVJWR7HEcfCwvypByvIUPBVgyoCpSzu3QrPCnbUzyM+FKjOxIYTUJWKnEX6Jc79pjgarK8iJeYSFmdZQi6szI5MbqlPkW96Ll6CxF4E6vMie+ncN4IGXnZ/4E4vlHdmSvrcUyI+gZ6rSCOg3heQUBBLYg7iOMpc1KJr7FOmpONPTtLKnhLdQdpDFRXqR0qJvsHBbzcIBXkdX+CNDrxHIvXjXiOxiCBjWBnBRU8QQK0HL/plfNDzf20y+1u5FjazU6vxLm2zZT3k4kxZCcD6NIyi57bbmAi7A415TtcPBmC7fsR2+keeCOd5b+ITpsRV/DyuEnCTH5HZ9xSjB1MORQoxlC+gmeIgzIZg28FERbnDeV70MLGls44C5mUPcffIRZ8QA+G5yGTR4vXLiSgQhaMkaG7t08Zm+SEGfkhukyIUY0JtYJUBfpXGM//UuhDiqLLA9jYQ8ozjEa0K89CNsK2rWkC5ckvyaAdvjZq48nXok9DwtWtEK6o7egp1mDhNwoZ0gueVnjvRVuKSHtLspEEOOPjiZQ5ep7sfYfkEMkM96wsXAE4fgM1JTz+UltouBLQxaZE8ssxRPKxP9yFknvP2nqKosRVe1wt4hV+CARiko8YnTHWbroNvj7UG8hAye+3ClxyqgPdHVx+WjLs9WfHqIDsr9yrtBh4ueZK0eJb/sAMKFqB85IGl6LLZMHCJgn/qZ6Sen3iKngGL+oBtEG6qo4AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.149256cdde2dc506091bb9f65d364005.svg";
export { ForwardRef as ReactComponent };